import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function ThumbsUp({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ThumbsUp</title>
      <path
        d="M3 10C3 9.44772 3.44772 9 4 9H7V21H4C3.44772 21 3 20.5523 3 20V10Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.75 11C7.75 10.5858 7.41421 10.25 7 10.25C6.58579 10.25 6.25 10.5858 6.25 11H7.75ZM7 19H6.25C6.25 19.2508 6.37533 19.4849 6.58397 19.624L7 19ZM14 8.25C13.5858 8.25 13.25 8.58579 13.25 9C13.25 9.41421 13.5858 9.75 14 9.75V8.25ZM8.9923 20.3282L8.57628 20.9522L8.9923 20.3282ZM20.6119 11.3288L19.8721 11.2055L20.6119 11.3288ZM19.8721 11.2055L18.678 18.3699L20.1576 18.6165L21.3517 11.4521L19.8721 11.2055ZM7.75 19V11H6.25V19H7.75ZM14 9.75H18.6391V8.25H14V9.75ZM16.4586 20.25H11.2111V21.75H16.4586V20.25ZM9.40833 19.7042L7.41603 18.376L6.58397 19.624L8.57628 20.9522L9.40833 19.7042ZM11.2111 20.25C10.5695 20.25 9.9422 20.0601 9.40833 19.7042L8.57628 20.9522C9.35655 21.4724 10.2733 21.75 11.2111 21.75V20.25ZM18.678 18.3699C18.4972 19.4548 17.5585 20.25 16.4586 20.25V21.75C18.2918 21.75 19.8562 20.4247 20.1576 18.6165L18.678 18.3699ZM21.3517 11.4521C21.631 9.77589 20.3384 8.25 18.6391 8.25V9.75C19.4115 9.75 19.9991 10.4436 19.8721 11.2055L21.3517 11.4521Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M13.2646 8.85291C13.1833 9.25908 13.4467 9.6542 13.8529 9.73544C14.2591 9.81667 14.6542 9.55326 14.7354 9.14709L13.2646 8.85291ZM8 11V11.75C8.28408 11.75 8.54378 11.5895 8.67082 11.3354L8 11ZM7 10.25C6.58579 10.25 6.25 10.5858 6.25 11C6.25 11.4142 6.58579 11.75 7 11.75V10.25ZM13.9517 5.41707L13.2646 8.85291L14.7354 9.14709L15.4226 5.71124L13.9517 5.41707ZM8.67082 11.3354L11.97 4.73711L10.6283 4.06629L7.32918 10.6646L8.67082 11.3354ZM8 10.25H7V11.75H8V10.25ZM13.2496 4.20709C13.7552 4.37565 14.0563 4.89438 13.9517 5.41707L15.4226 5.71124C15.6755 4.44676 14.9472 3.19185 13.7239 2.78406L13.2496 4.20709ZM13.7239 2.78406C12.5167 2.38168 11.1974 2.92816 10.6283 4.06629L11.97 4.73711C12.2052 4.26665 12.7506 4.04076 13.2496 4.20709L13.7239 2.78406Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
